import React, { useEffect, useState } from "react";
import styles from "./Internet.module.css";
import CommonStyle from "../../../GlobalComponent/CommonStyle/CommonStyle.module.css";

const NoInternet = () => {
  const [statusMessage, setStatusMessage] = useState("Checking connection...");
  const [isChecking, setIsChecking] = useState(false);
  const [btnText, setBtnText] = useState("Try Again");

  // Retry handler
  const retryConnection = () => {
    setIsChecking(true);
    setBtnText("Checking...");
    setStatusMessage("Testing connection...");

    setTimeout(() => {
      if (navigator.onLine) {
        setStatusMessage("Connection restored! 🎉");
        setBtnText("Reload Page");
      } else {
        setStatusMessage("Still no connection. Please check your network.");
        setBtnText("Try Again");
      }
      setIsChecking(false);
    }, 2000);
  };

  // Listen to online/offline events
  useEffect(() => {
    if (navigator.onLine) {
      setStatusMessage("Connection available - this is just a demo!");
    } else {
      setStatusMessage("No internet connection detected");
    }

    const handleOnline = () => setStatusMessage("Connection restored! 🎉");
    const handleOffline = () => setStatusMessage("Connection lost");

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className="max-w-md w-full text-center">
        {/* WiFi Icon */}
        <div className={`${styles.wifiIcon} ${styles.bounce} mx-auto mb-8`}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            className="w-full h-full text-white"
          >
            <path
              d="M12 20h.01M8.5 16.5a5 5 0 0 1 7 0M5 13a10 10 0 0 1 14 0M1.5 9.5a15 15 0 0 1 21 0"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div className={styles.wifiSlash}></div>
        </div>

        {/* Main Message */}
        <h1 className={styles.heading1}>
          Oops! No Internet
        </h1>
        <p className={styles.heading2}>
          It looks like you're not connected to the internet. Check your
          connection and try again.
        </p>

        {/* Suggestions */}
        <div className={styles.maincard}>
          <h2 className={styles.heading3}>
            Try these steps:
          </h2>
          <ul className="text-left space-y-3 text-white">
            <li className={styles.heading3points}>
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
              Check your WiFi connection
            </li>
            <li className={styles.heading3points}>
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
              Restart your router
            </li>
            <li className={styles.heading3points}>
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
              Check network cables
            </li>
            <li className={styles.heading3points}>
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
              Contact your ISP if issues persist
            </li>
          </ul>
        </div>

        {/* Retry Button */}
        <button
          onClick={() =>
            btnText === "Reload Page" ? window.location.reload() : retryConnection()
          }
          disabled={isChecking}
          
          className={`${styles.reloadbutton} ${
            isChecking ? "opacity-75 cursor-not-allowed" : ""
          }`}
        >
          {btnText}
        </button>

        {/* Status Message */}
        <div
          className={`${styles.headingmessage} ${
            statusMessage.includes("lost") || statusMessage.includes("no")
              ? "text-danger"
              : "text-success"
          } ${isChecking ? styles.pulse : ""}`}
        >
          {statusMessage}
        </div>
      </div>
    </div>
  );
};

export default NoInternet;
